<template>
  <b-overlay
    :show="loader"
    opacity="0.50"
    rounded="sm"
  >
    <div>
      <app-collapse
        accordion
        type="default"
      >
        <app-collapse-item
          v-model="collapseHistorial"
          title="Historial de aportaciones"
          @visible="onCollapseHistorial"
        >
          <!-- aportacion -->
          <b-list-group class="mt-2 recursos-list">
            <b-list-group-item
              v-for="(aportacion, index) in fetchHistorial"
              :key="index"
              class="recurso-item"
            >
              <div class="recurso-row">
                <feather-icon
                  icon="HexagonIcon"
                  class="text-primary"
                />
                {{ aportacion.concepto.concepto }}
              </div>
              <div class="recurso-row">
                <feather-icon
                  icon="DollarSignIcon"
                  class="text-success"
                />
                {{ aportacion.monto }}
              </div>
              <div class="recurso-row">
                <feather-icon
                  icon="CalendarIcon"
                  class="text-warning"
                />
                {{ aportacion.fecha_inicio_f }}
              </div>
              <div class="recurso-row">
                <feather-icon
                  icon="CalendarIcon"
                  class="text-info"
                />
                {{ aportacion.fecha_fin_f }}

              </div>
              <div class="recurso-row">
                <feather-icon
                  icon="MessageCircleIcon"
                />
                {{ aportacion.comentarios || '' }}
              </div>
              <div class="recurso-row">
                <feather-icon
                  icon="UserIcon"
                />
                Editdo por: {{ aportacion.nombre || '' }}
              </div>
            </b-list-group-item>
          </b-list-group>
        </app-collapse-item>
      </app-collapse>

    </div>
  </b-overlay>
</template>

<script>
import {
  BOverlay, BListGroupItem, BListGroup, VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  ref, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getData } from '@core/utils/http/general'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    BOverlay,
    BListGroupItem,
    BListGroup,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    idplan: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const loader = ref(false)
    const fetchHistorial = ref([])
    const toast = useToast()
    const historialCargado = ref(false)
    const collapseHistorial = ref(false)

    const getHistorial = q => {
      loader.value = true
      getData({ action: 13, token: store.state.cuenta.session.token, q }, 'wsplanEstudios')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) fetchHistorial.value = response.data.data
          else {
            toast({
              component: ToastificationContent,
              props: {
                title: `${response.data.status} - Sección en construcción`,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
          loader.value = false
        }).catch(err => {
          loader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error, No hay conexión',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    const cargarHistorial = () => {
      getHistorial(props.idplan)
    }

    const onCollapseHistorial = () => {
      if (!historialCargado.value) {
        cargarHistorial()
        historialCargado.value = true
      }
    }

    watch(() => props.idplan, () => {
      fetchHistorial.value = []
      historialCargado.value = false
      collapseHistorial.value = false
    })

    return {
      // loader
      fetchHistorial,
      loader,

      onCollapseHistorial,
      collapseHistorial,
      getHistorial,
    }
  },
}
</script>

<style scoped>

/* Recursos */
.recursos-list {
  border-left: 3px solid #adadad;
  margin-left: 0.5rem;
}

.recurso-item {
  border: none;
  background: #f7f7f7;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
}

.recurso-row {
  font-size: 0.85rem;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

  </style>
